import ApiService from 'app/services/ApiService';

export const GET_MULTIMEDIA_REQUEST = 'GET_MULTIMEDIA_REQUEST';
export const GET_MULTIMEDIA_SUCCESS = 'GET_MULTIMEDIA_SUCCESS';
export const GET_MULTIMEDIA_FAILURE = 'GET_MULTIMEDIA_FAILURE';

export const GET_MULTIMEDIA_FILTERS = 'GET_MULTIMEDIA_FILTERS';

// Training:
export const GET_MULTIMEDIA_TRAINING_REQUEST = 'GET_MULTIMEDIA_TRAINING_REQUEST';
export const GET_MULTIMEDIA_TRAINING_SUCCESS = 'GET_MULTIMEDIA_TRAINING_SUCCESS';
export const GET_MULTIMEDIA_TRAINING_FAILURE = 'GET_MULTIMEDIA_TRAINING_FAILURE';

// Specialty Training Media:
export const GET_MULTIMEDIA_SPECIALTY_TRAINING_REQUEST = 'GET_MULTIMEDIA_SPECIALTY_TRAINING_REQUEST';
export const GET_MULTIMEDIA_SPECIALTY_TRAINING_SUCCESS = 'GET_MULTIMEDIA_SPECIALTY_TRAINING_SUCCESS';
export const GET_MULTIMEDIA_SPECIALTY_TRAINING_FAILURE = 'GET_MULTIMEDIA_SPECIALTY_TRAINING_FAILURE';

// Register Filter:
export const SAVE_FILTER_COTPLAYHUB = 'SAVE_FILTER_COTPLAYHUB';

//Finished media hub
export const FINISHED_MEDIA_HUB_REQUEST = 'FINISHED_MEDIA_HUB_REQUEST';
export const FINISHED_MEDIA_HUB_SUCCESS = 'FINISHED_MEDIA_HUB_SUCCESS';
export const FINISHED_MEDIA_HUB_FAILURE = 'FINISHED_MEDIA_HUB_FAILURE';
export const FINISHED_MEDIO_HUB_RELOAD_VIEWS = 'FINISHED_MEDIO_HUB_RELOAD_VIEWS';

export const getMedia = (params) => dispatch => {
    dispatch({ type: GET_MULTIMEDIA_REQUEST });
    ApiService.getMediaCourses(params).then(
        response => {
            dispatch({
                type: GET_MULTIMEDIA_SUCCESS,
                payload: response.listData,
                params: params,
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_MULTIMEDIA_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const getMedFilters = (params) => dispatch => {
    ApiService.getMediaFilters(params).then(
        response => {
            dispatch({
                type: GET_MULTIMEDIA_FILTERS,
                payload: response,
            });
        }
    ).catch(
        (error) => {
            dispatch({
                type: GET_MULTIMEDIA_FILTERS,
                payload: []
            });
        }
    )
}

export const getMediaMostViewed = (params) => dispatch => {
    dispatch({ type: GET_MULTIMEDIA_REQUEST });
    ApiService.getMediaCoursesMostViewed(params).then(
        response => {
            dispatch({
                type: GET_MULTIMEDIA_SUCCESS,
                payload: response.listData,
                params: params,
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_MULTIMEDIA_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const trainingNamesMediaVideo = () => dispatch => {
    dispatch({ type: GET_MULTIMEDIA_TRAINING_REQUEST });
    ApiService.trainingNamesMediaVideo().then(
        response => {
            dispatch({
                type: GET_MULTIMEDIA_TRAINING_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_MULTIMEDIA_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const specialtyMediaVideo = (params) => dispatch => {
    dispatch({ type: GET_MULTIMEDIA_SPECIALTY_TRAINING_REQUEST });
    ApiService.specialtyMediaVideo(params).then(
        response => {
            dispatch({
                type: GET_MULTIMEDIA_SPECIALTY_TRAINING_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_MULTIMEDIA_SPECIALTY_TRAINING_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const finishedMediaHub = (data) => dispatch => {
    dispatch({ type: FINISHED_MEDIA_HUB_REQUEST });
    ApiService.finishedMediaHub(data).then(
        response => {
            dispatch({
                type: FINISHED_MEDIA_HUB_SUCCESS
            });



            ApiService.LoadReviewsbyIdCourse(data.idCourse).then(response => {
                if (response.success) {
                    dispatch({
                        type: FINISHED_MEDIO_HUB_RELOAD_VIEWS,
                        payload: {
                            idCourse: data.idCourse,
                            views: response.data
                        }
                    })
                }
            })



        }
    ).catch(
        (error) => {
            dispatch({ type: FINISHED_MEDIA_HUB_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}

export const timeMediaHub = (data) => dispatch => {
    ApiService.setVideoSeconds(data).then(
        response => {

        }
    ).catch(
        (error) => {
            dispatch({ type: FINISHED_MEDIA_HUB_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message });
        }
    )
}




// export const LoadReviews = ( data ) => dispatch => {
//     ApiService.LoadReviewsbyIdCourse( data ).then(response => {
//         if( response.success ){
//             dispatch({
//                 type: FINISHED_MEDIO_HUB_RELOAD_VIEWS,
//                 payload: {
//                     idCourse: data,
//                     views: response.data
//                 }
//             })
//         }
//     })
// }

export const saveFilter = (filter) => ({
    type: SAVE_FILTER_COTPLAYHUB,
    payload: filter
});